export function getModals(state) {
    return state.selects.modals;
}